<form
  autocomplete="off"
  #editInsertCommonSettingModal="ngForm"
  (ngSubmit)="save()"
>
  <mat-dialog-content style="width: 250px">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field>
          <mat-select name="selectLanguage" [(ngModel)]="selectedLanguage">
            <mat-option *ngFor="let entity of languages" [value]="entity.name">
              <i [class]="entity.icon"></i> {{ entity.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <br />
  </mat-dialog-content>
  <div mat-dialog-actions class="mb24 bgcgrey" align="end">
    <button mat-button type="button" class="bgcw" (click)="close(false)">
      {{ "Cancel" | localize }}
    </button>
    <button mat-flat-button type="submit" flex="15" color="primary">
      {{ "Save" | localize }}
    </button>
  </div>
</form>
